import comp from "./DurationAndPrescribedPractical";
export default comp;
